import React, { useState } from 'react';
import { CiCirclePlus } from 'react-icons/ci';
import { RiDeleteBin6Line } from 'react-icons/ri';
import ImagePreviewModal from '../../common/ImagePreviewModal';

function ImageUploader({
  getImagesUrl,
  coverImg,
  setCoverImg,
  onImageRemove,
  maxNumber,
  setCropperOpen,
  fileUploadRefs,
  numberOfImages,
  setNumberOfImages,
}) {
  const [images, setImages] = useState(coverImg || []); // Start with images passed in the prop
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState("");

  const handleDeleteImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);
    if (onImageRemove) {
      onImageRemove(index);
    }
  };

  const handlePreview = (img) => {
    setPreviewSrc(img);
    setPreviewModalOpen(true);
  };

  return (
    <>
      <div className="container scroll-hide" style={{ overflowX: "scroll", overflowY: "hidden" }}>
        <div className="row" style={{ display: "flex", flexWrap: "nowrap" }}>
          {/* Display newly uploaded images */}
          {images.map((image, index) => (
            <div key={index + coverImg.length} className="col-auto mb-3 position-relative">
              <div className="image-wrapper">
                <img
                  src={image}
                  alt={`Upload ${index + 1}`}
                  className="uploaded-image-thumbnail cursor"
                  onClick={() => handlePreview(image)}
                />
                <div className="image-options">
                  <button
                    className="btn btn-link "
                    onClick={() => handleDeleteImage(index)}
                  >
                    <RiDeleteBin6Line />
                  </button>
                  {/* Add edit functionality if needed */}
                  <button
                    className="btn btn-link text-primary"
                  //   onClick={() => handleEditImage(index + coverImg.length)}
                  >
                    <i className="bi bi-pencil"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}

          {/* Button to add more images */}
          {numberOfImages < maxNumber && (
            <div className="col-auto">
              <div
                className="upload-image-button"
                onClick={() => fileUploadRefs[numberOfImages - 1]?.current.click()}
              >
                <CiCirclePlus size={20} />
                <div className="mt-2">Add more images</div>
              </div>
            </div>
          )}
        </div>
      </div>

      <ImagePreviewModal
        isOpen={previewModalOpen}
        toggle={() => setPreviewModalOpen(!previewModalOpen)}
        imageSrc={previewSrc}
        alt="Image Preview"
        zIndex={10060}
      />
    </>
  );
}

export default ImageUploader;
